

















import { Component, Vue, Prop } from "vue-property-decorator";

export interface SelectOption {
  value: string;
  text: string;
}

@Component<CSelect>({
  watch: {
    value() {
      this.tmpValue = this.value;
    },
    tmpValue() {
      if (this.value !== this.tmpValue) {
        this.$emit("input", this.tmpValue);
      }
    }
  }
})
export default class CSelect extends Vue {
  tmpValue: string | null = "";

  @Prop({ type: String, required: false, default: null })
  name!: string | null;

  @Prop({ type: Array, required: false, default: [] })
  options!: SelectOption[];

  @Prop({ type: String, required: false, default: null }) value!: string | null;

  @Prop({ type: String, required: false, default: "選択してください" })
  description!: string;

  mounted() {
    this.tmpValue = this.value;
  }
}
